import React, { useEffect, useRef, useState, useMemo } from "react";
import styles from "./styles.module.css";
import backgroundImage from "../images/Lucky7/tableBg.jpg";
import newRoundImg from "../images/Lucky7/New_Round.svg";
import welcome from "../images/Lucky7/welcome.gif";
import ideal from "../images/Lucky7/idle.gif";
import clapping from "../images/Lucky7/clapping.gif";
import crown from "../images/Lucky7/crown.png";
import closedCard from "../images/Lucky7/closed-card.jpg";

import { cards } from "../images/index";
import GameAreaLoader from "../../Loader/GameAreaLoader";
import useGameScreenLoader from "../../../api/useGameScreenLoader";
import useRoundLoader from "../../../api/useRoundLoader";

const mapCardStringToAsset = (cardString) => {
  if (!cardString || typeof cardString !== 'string') return closedCard;
  const raw = cardString.trim().toUpperCase();
  let normalized = raw;
  if (raw.length === 2 && /^[0-9A-K][HSCD]$/i.test(raw)) {
    normalized = `${raw[0]}${raw[1]}${raw[1]}`;
  }
  return cards[normalized] || cards[`${normalized}.webp`] || 
         cards[raw] || cards[`${raw}.webp`] || closedCard;
};

export default function GameScreen({ 
  bettingClosed, 
  animationTime,   
  settledData, 
  onStageComplete,
  remainingTime,
  socketData,
  onAnimStart,
  onAnimEnd
}) {

  const [showCard, setShowCard] = useState(false);
  const [showWinner, setShowWinner] = useState(false);
  const [currentGif, setCurrentGif] = useState(ideal);
const roundId = socketData?.roundId;
const settlementt = socketData?.settlement;

const { gameScreenLoader, processingLoader } = useGameScreenLoader(roundId, !!settlementt, 5000);

  const timeoutRefs = useRef([]);
  const wasBettingClosedRef = useRef(false);
  const getSettlement = (settledData) => settledData?.data ?? settledData ?? null;
  const settlement = getSettlement(settledData);
  const clearAllTimeouts = () => {
    timeoutRefs.current.forEach(t => clearTimeout(t));
    timeoutRefs.current = [];
  };

useEffect(() => {
    clearAllTimeouts();

    if (!bettingClosed) {
      if (wasBettingClosedRef.current && onAnimEnd) {
        onAnimEnd();
      }
      wasBettingClosedRef.current = false;
      resetToNewRound();
      return;
    }

    if (!wasBettingClosedRef.current && onAnimStart) {
      onAnimStart();
    }
    wasBettingClosedRef.current = true;

    if (!settlement?.drawnCard) {
      setCurrentGif(ideal);
      setShowCard(false);
      setShowWinner(false);
      return;
    }

    const isIdle = !!settlement.idle;
    const isWinner = !!settlement.winner;

    const handleRevealSequence = () => {
      if (animationTime >= 7) {
        setShowCard(false);
        setShowWinner(false);
        setCurrentGif(ideal);
      }
      else if (animationTime <= 6 && animationTime > 0) {
        setShowCard(true);

        if (isIdle) {
          // idle round: show the card, never show winner/clapping
          setShowWinner(false);
          setCurrentGif(ideal);
        } else if (isWinner) {
          setShowWinner(animationTime <= 4);
          setCurrentGif(animationTime <= 4 ? clapping : ideal);
        } else {
          setShowWinner(false);
          setCurrentGif(ideal);
        }
      }
    };

    handleRevealSequence();

    if (animationTime === 0) {
      const t = setTimeout(() => {
        resetToNewRound();
        if (onAnimEnd) onAnimEnd();
        wasBettingClosedRef.current = false;
        if (onStageComplete) onStageComplete();
      }, 800);
      timeoutRefs.current.push(t);
    }

    return () => clearAllTimeouts();
  }, [bettingClosed, animationTime, settlement]);
  const resetToNewRound = () => {
    clearAllTimeouts();
    setShowCard(false);
    setShowWinner(false);
    setCurrentGif(welcome); // or ideal
  };

  return (
    <GameAreaLoader showLoader={gameScreenLoader}>
      <div className={styles.lucky7GameContainer}>
        <div className={styles.lucky7MainArea}>
          <div className={styles.lucky7VideoArea}>
            <div className={styles.lucky7VideoContainer}>
              <img 
                src={backgroundImage} 
                alt="Background" 
                className={styles.lucky7BackgroundImage} 
                draggable={false} 
              />

              {/* {!bettingClosed && remainingTime >= 26 && (
                <div className={styles.lucky7NewRoundOverlay}>
                  <img src={newRoundImg} alt="New Round" className={styles.lucky7NewRoundImage} draggable={false} />
                </div>
              )} */}

              {/* GIF Overlay */}
              <div className={styles.lucky7GifOverlay}>
                <img 
                  src={currentGif} 
                  alt="animation" 
                  className={styles.lucky7GifImage} 
                  draggable={false} 
                />
              </div>

             {/* Card Display */}
<div className={styles.lucky7CardContainer}>
  <div className={styles.lucky7CardSection}>
    <img
      src={showCard && settlement?.drawnCard 
        ? mapCardStringToAsset(settlement.drawnCard) 
        : closedCard}
      alt="Lucky 7 Card"
      className={styles.lucky7CardImage}
      draggable={false}
    />
  </div>
</div>

{/* Winner Display */}
{showWinner && settlement?.outcome && (
  <div className={styles.lucky7WinnerAnimation}>
    <img src={crown} alt="Crown" className={styles.lucky7CrownImage} />
    <span className={styles.lucky7WinnerText}>
      {settlement.outcome.split(',')[0].trim().toUpperCase()}
    </span>
  </div>
)}
            </div>
          </div>
        </div>
        {processingLoader && (
  <div className="dataProcessingOverlay">
    <div className="cardSpinner" />
  </div>
)}
      </div>
    </GameAreaLoader>
  );
}